import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import { FORM } from 'src/constants/Form';
import { useState } from 'react';
import { changeUserEmail } from 'src/redux/actions/userActions';

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  title: {
    fontWeight: 'bold',
    width: '100px',
  },
}));

const ChangeEmailDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const [payload, setPayload] = useState({
    email: '',
    password: '',
  });

  const opened =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.changeEmail]) {
        return state.dialog[DIALOGS.changeEmail].opened;
      }
      return false;
    });

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.changeEmail }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.changeEmail }));
    dispatch(changeUserEmail(payload));
  };

  const handleOnChange = (value: Value, field: string) => {
    setPayload({
      ...payload,
      [field]: value,
    });
  };

  return (
    <Dialog
      aria-labelledby="change-email"
      open={opened}
      maxWidth="sm"
      PaperProps={{
        style: {
          width: '100%',
        },
      }}>
      <DialogTitle id="change-email">Change Your Email</DialogTitle>
      <DialogContent dividers>
        <div className={classes.row}>
          <span className={classes.title}>New Email:</span>
          <FormTextField
            form={FORM.changeEmail}
            label="New Email"
            name="email"
            onChange={handleOnChange}
            required
            value={payload.email}
            margin="dense" />
        </div>
        <div className={classes.row}>
          <span className={classes.title}>Password:</span>
          <FormTextField
            form={FORM.changeEmail}
            label="Password"
            name="password"
            onChange={handleOnChange}
            required
            value={payload.password}
            margin="dense" />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Change Email
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeEmailDialog;
